import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textDetailRespons: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  viewDetail: {
    flexDirection: "row",
    paddingHorizontal: 38.5,
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    minHeight: 127,
    alignItems: "center",
    paddingVertical: 10,
  },
  imgDetail: {
    maxWidth: 120,
    width: "100%",
    height: 120,
    borderRadius: 5,
  },
  imgDetailRespons: {
    maxWidth: 100,
    width: "100%",
    height: 100,
    borderRadius: 5,
  },
  buttomDetail: {
    maxWidth: 65,
    width: "100%",
    height: 40,
    backgroundColor: "#fff",
    borderRadius: 9,
    marginTop: 13,
    justifyContent: "center",
  },
  textButtonDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
  textButtonDetailRespons: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2D69AE",
    alignSelf: "center",
  },
});
export const stylesResponsive = StyleSheet.create({
  textDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  viewDetail: {
    flexDirection: "row",
    paddingHorizontal: 38.5,
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    paddingVertical: 20,
  },
  textTopic: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 10,
  },
});
